// extracted by mini-css-extract-plugin
export var container = "_ht-1";
export var cornerButtonContainer = "_ht-6";
export var disabled = "_ht-2";
export var dragActive = "_ht-3";
export var fileContainer = "_ht-5";
export var hiddenInput = "_ht-4";
export var widthContainer = "_ht-0";